import { render } from "./UnidadeForm.vue?vue&type=template&id=4d6b5832&scoped=true"
import script from "./UnidadeForm.vue?vue&type=script&lang=js"
export * from "./UnidadeForm.vue?vue&type=script&lang=js"

import "./UnidadeForm.vue?vue&type=style&index=0&id=4d6b5832&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6b5832"]])

export default __exports__